const origin = typeof window !== 'undefined' ? window.location.origin : '';

function isNativeApp() {
  return typeof window !== 'undefined' && Boolean(window.Capacitor?.isNativePlatform?.());
}

// Native WebView is served from localhost, so API/socket must hit the public server.
const NATIVE_HOST = process.env.REACT_APP_NATIVE_HOST || 'http://185.206.95.192';

export const API_URL = isNativeApp()
  ? `${NATIVE_HOST}/api`
  : process.env.REACT_APP_API_URL || '/api';

export const SOCKET_URL = isNativeApp()
  ? NATIVE_HOST
  : process.env.REACT_APP_SOCKET_URL || origin;

export function mediaUrl(path) {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  const base = isNativeApp() ? NATIVE_HOST : origin;
  return `${base}${path.startsWith('/') ? path : `/${path}`}`;
}

export { isNativeApp };
